import { usePostArticleCommentApi } from '@/entities/article';
import { CommentTextarea } from '@/shared/Components';
import { useComment, useDebounce, useProfile } from '@/shared/hooks';

interface ArticleCommentFormProps {
  newsId: string;
  totalCommentCount?: number;
  onPageChange?: (index: number) => void;
  setNewCommentId?: (index: number) => void;
}

const COMMENTS_PER_PAGE = 10;

const ArticleCommentForm = ({
  newsId,
  onPageChange,
  setNewCommentId,
  totalCommentCount,
}: ArticleCommentFormProps) => {
  const { profile } = useProfile();
  const [newComment, onNewCommentChange, resetComment] = useComment('');
  const { mutate, isPending } = usePostArticleCommentApi();

  const handleSubmitNewComment = useDebounce(() => {
    const hasNothingToPost =
      totalCommentCount === undefined || !newComment.trim();

    if (hasNothingToPost || isPending) return;

    const totalComments = totalCommentCount + 1;
    const lastPage = Math.ceil(totalComments / COMMENTS_PER_PAGE);

    mutate(
      {
        newsId,
        comment: newComment.trim(),
        page: lastPage,
      },
      {
        onSuccess: (data) => {
          const newId = data.id;
          resetComment();
          onPageChange?.(lastPage);
          setNewCommentId?.(newId);
        },
      }
    );
  });

  return (
    <CommentTextarea
      maxLength={500}
      userId={profile?.name}
      imgUrl={profile?.imgSrc}
      guideText="건전한 댓글 문화를 위해 불쾌감을 주는 욕설, 특정 대상을 비하하는 댓글은 표시가 제한됩니다."
      placeholder="댓글 작성 시 상대방에 대한 배려와 책임을 담아주세요."
      buttonName="작성하기"
      value={newComment}
      onChange={onNewCommentChange}
      onSubmit={handleSubmitNewComment}
    />
  );
};

export default ArticleCommentForm;
